/** @jsxImportSource @emotion/core */
import { css } from '@emotion/core';
import React from 'react';

import { Flex } from 'components/styled';
import { NavButton, NavLinkButton } from 'components/styled/Button';

type LoginBoxProps = {
	icon: React.FC<React.SVGProps<SVGSVGElement>>;
	onLogin: () => void;
	onRegister: () => void;
	redirectUrl: string;
};

const LoginBox: React.FC<LoginBoxProps> = ({
	icon: Icon,
	onLogin,
	redirectUrl,
	children,
}) => (
	<Flex
		mx={[0, 3]}
		my={[2, 4]}
		width={[1, 'auto']}
		color="white"
		alignItems="center"
		flexDirection="column"
	>
		<Flex
			justifyContent="center"
			alignItems="center"
			size={[40, 66]}
			p={[2, 3]}
			bg="rgba(0,0,0,0.5)"
			css={css`
				border-radius: 50%;
			`}
		>
			<Icon
				css={css`
					color: white;
					width: 100%;
					height: 100%;
				`}
			/>
		</Flex>

		<Flex
			fontSize={['lg', 'xl']}
			flexGrow={1}
			flexDirection={['row', 'column']}
			justifyContent="center"
			py={[2, 4]}
			textAlign="center"
		>
			{children}
		</Flex>
		<Flex flexDirection="column">
			<NavButton
				onClick={onLogin}
				variant="primary"
				sizeType="big"
				mt={[1, 0]}
				py={2}
			>
				Vstoupit
			</NavButton>
			<NavLinkButton to={redirectUrl} mt={1} py={2}>
				Zjistit více
			</NavLinkButton>
		</Flex>
	</Flex>
);
export default LoginBox;
